import { Directive } from '@angular/core';

@Directive({
    selector: 'input[qpxPhone]',
    host: {
        '[attr.type]': '"tel"',
        '[attr.inputmode]': '"tel"',
        '[attr.autocomplete]': '"tel"',
    },
})
export class QpxPhone {}
